module.exports = __webpack_public_path__ + "static/photo-fb2d4bceb101cc9589110b96cfec35f1.jpg";